/*
 * @Author: bbqin
 * @Date: 2022-10-21 14:40:59
 * @LastEditTime: 2022-10-25 19:14:30
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\libs\utils.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { getSafeRandom } from '@platform/api';

/**
 * 字符匹配
 * 模糊匹配等
 * @ignore
 * @memberof MetaFieldSetting
 * @param {string} str 
 * @param {string} rule 
 * @param {string} type 
 * @returns {boolean}
 */
export function match(str = '', rule = '', type) {
    if (rule === '') {
        return false;
    }
    if (type === 'like') {
        return String(str).toLocaleLowerCase().indexOf(String(rule).toLocaleLowerCase()) !== -1;
    }
    return String(str).indexOf(String(rule)) !== -1;
}

/**
 * 生成唯一标识
 */
export function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (getSafeRandom() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}